import { Observable } from 'rxjs';

export abstract class HttpBaseUrlProvider {
  public abstract getUrl(): Observable<string>;
}
